import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import { generateConnectionId, getConnectionId, init_pubsub } from "./tripPlanner_new/pubsub_util";
import { hide_map_loadingIcon, initMap_tripPlanner, show_map_loadingIcon } from "./tripPlanner_new/ui_utils";
import { getAccess, getAllFeatureFlags, getCookie, getCookie_base64, getHash, getTrip_cachedForm, handleSharePopup, setCookie } from "./util/general_util";

import Map from 'ol/Map';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { POI_Data, Trip_v2 } from "./util/tripPlanner_types";
import { get_genieTrip, getGenieTripFromID, getPublishedTrip, getSaveTripBtn, getShareTripBtn, getTripFromID, send_getCurTrip } from "./tripPlanner_new/api_utils";

import { init_preSearch_listeners } from "./tripPlanner_new/eventListeners/preSearch";
import { handle_saveTrip_form, init_generalUI_listeners } from "./tripPlanner_new/eventListeners/generalUI";
import { init_searchEvent_listeners } from "./tripPlanner_new/eventListeners/searchEvents";
import { init_tripAction_listeners } from "./tripPlanner_new/eventListeners/tripActions";
import { init_controlPanel_listeners } from "./tripPlanner_new/eventListeners/controlPanel";
import { init_customEventListeners } from "./tripPlanner_new/eventListeners/customEventListeners";
import { display_trip } from "./tripPlanner_new/tripPlanner_scripts";
import { build_trip_from_query_args } from "./tripPlanner_new/trip_search_scripts";

import { init_rentalFilters } from './rv_share_integration';
import { init_rvShare_listeners } from "./tripPlanner/eventListeners/rvShare_integration_listeners";
import { Feature } from 'ol';
import { check_interaction_counter, reset_interaction_counter } from './tripPlanner_new/util/helper_functions';


declare global {
	interface Window {
		mainTripPlannerMap_localContextMapView:google.maps.localContext.LocalContextMapView;
		mainTripPlannerMap:Map;
		tripPlannerCurrentTrip:Trip_v2;
		directionsService:google.maps.DirectionsService;
		mainMapDirectionsRenderer:google.maps.DirectionsRenderer;
		mainMapMarkerInfoWindowShown:boolean;
		featureFlags:Record<string,LDClient.LDFlagValue>;
		initTripState:string;
		bootstrap:any;
		GAsubLevel:string;

		curAutofillInput:JQuery<HTMLInputElement>;

		poisOnRouteActive:boolean;
		walmartsOnRouteActive:boolean;

		currentPOIoptions:POI_Data[];

		rvRental_sDate_pickr:any;
        rvRental_eDate_pickr:any;

		copilotHistory:Array<{input:string,response:string}>|undefined;

		openStopTabIds:string[]|undefined;

		enlargedStopIcon:Feature|undefined;

		stayRadiusHistogram:number[][];

		favoritedCamps:number[]|void;
	}
};

if (window.tripPlannerCurrentTrip == null || window.tripPlannerCurrentTrip == undefined) {
	window.tripPlannerCurrentTrip = {
		stopListHTML: null,
		queries: null,
		filters: null,
		name: null,
		desc: null,
		tripID: null,
		startDate:null,
		lockedLegs:null,
		legs:null,
		directions:null,
		autoFillData:null
	};
};

window.poisOnRouteActive = false;

async function onload() {
	switch ($("[dist-unit-select]").val()) {
		case "mi":
			$("[driveDistOption-label]").each(function(idx,el) {
				$(el).html($(el).html().replace("Kilometers","Miles").replace("kilometers","miles"));
			});
      		$(".dist-unit-suffix").html("mi");
			break;
		case "km":
			$("[driveDistOption-label]").each(function(idx,el) {
				$(el).html($(el).html().replace("Miles","Kilometers").replace("miles","kilometers"));
			});
			$(".dist-unit-suffix").html("km");
			break;
		default:
			break;
	};

	if (window.featureFlags == undefined || window.featureFlags.freemiumAccess == undefined) {
		await getAllFeatureFlags();
	};

	if (getCookie("tp-trial-req").length == 0) {
		if (window.featureFlags.freemiumAccess.block_nonSub_usage) {
			setCookie("tp-trial-req","t","", 14);
		} else {
			setCookie("tp-trial-req","f","", 14);
		};
	};
	if (getCookie("tp-int-camp").length == 0) {
		if (window.featureFlags.freemiumAccess.interactionCap) {
			setCookie("tp-int-cap",JSON.stringify(window.featureFlags.freemiumAccess.interactionCap),"", 14);
		};
	};

	init_preSearch_listeners();
	init_generalUI_listeners();
	init_searchEvent_listeners();
	init_tripAction_listeners();
	init_controlPanel_listeners();
	init_customEventListeners();

	init_rentalFilters();
	init_rvShare_listeners();

    ////// PubSub connection id
    generateConnectionId();

    $.ajaxSetup({
        beforeSend: function(xhr) {
            xhr.setRequestHeader("connectionId", getConnectionId())
        }
    });
    /////
    init_pubsub();

    await initMap_tripPlanner();

	let swiperConfig:any = JSON.parse($("#genieJourneySwiper").attr("data-swiper-options"));
	// swiperConfig["modules"] = [Navigation,Pagination];
	swiperConfig["modules"] = [Pagination, Autoplay];
	const swiper = new Swiper(
		"#genieJourneySwiper",
		swiperConfig
	);

	if (getCookie("gw-dismiss") == "t") {
		$("[genie-wish-info]").remove();
	};

    const url_search_params = new URLSearchParams(window.location.search);


    if (url_search_params.get("id") != null) {
		show_map_loadingIcon("Loading your trip");
		$("#tripSearchModal").hide();
		getTripFromID(url_search_params.get("id")).then(trip => {
			window.tripPlannerCurrentTrip = trip;
			hide_map_loadingIcon();
			$("#tripSearchModal").remove();

			display_trip(trip, true);

			reset_interaction_counter();

			window.initTripState = getHash(JSON.stringify(getTrip_cachedForm(trip)));

			getSaveTripBtn().then(btnHtml => {
				$("#saveTripWrap").html(btnHtml);
				$("#saveTripForm").on("submit", handle_saveTrip_form);
			}).catch(e => {
				console.error(e);
			});
			getShareTripBtn().then(btnHtml => {
                $("#shareTripWrap").html(btnHtml);
                $("[tripPrivacyBtn]").off("click");
                $("[tripPrivacyBtn]").on("click", handleSharePopup);
            });
		}).catch(e => {
			console.error(e);
			hide_map_loadingIcon();
			$("#tripSearchModal").show();
			window.history.replaceState({}, document.title, "/tripPlanner");
		});

    } else if (url_search_params.get("genieTripId") != null ) {
		show_map_loadingIcon("Loading your trip");
		$("#tripSearchModal").hide();
		getGenieTripFromID(url_search_params.get("genieTripId")).then(trip => {
			window.tripPlannerCurrentTrip = trip;
			hide_map_loadingIcon();
			$("#tripSearchModal").remove();
			display_trip(trip, true);
			reset_interaction_counter();
			display_trip(trip, true);
		}).catch(e => {
			console.error(e);
			hide_map_loadingIcon();
			$("#tripSearchModal").show();
			window.history.replaceState({}, document.title, "/tripPlanner");
		});
	} else if (url_search_params.get("genieTrip") != null) {
		let driveTime:number = parseInt(url_search_params.get("driveTime"));
		let driveDist:number = parseInt(url_search_params.get("driveDist"));
		let routeWidth:number = parseInt(url_search_params.get("routeWidth"));
		let avoidHighways:number = parseInt(url_search_params.get("avoidHighways"));
		let driveTime_str:string;
		let routeStart_query:string|null  = decodeURIComponent(url_search_params.get("start"));
		if (routeStart_query == "null") routeStart_query = null;
		let routeStart_query_type:string|null = decodeURIComponent(url_search_params.get("start_query_type"));
		if (routeStart_query_type == "null") routeStart_query_type = null;
		let routeStart_query_val:string|null = decodeURIComponent(url_search_params.get("start_query_val"));
		if (routeStart_query_val == "null") routeStart_query_val = null;
		let routeEnd_query:string|null = decodeURIComponent(url_search_params.get("end"));
		if (routeEnd_query == "null") routeEnd_query = null;
		let routeEnd_query_type:string|null = decodeURIComponent(url_search_params.get("end_query_type"));
		if (routeEnd_query_type == "null") routeEnd_query_type = null;
		let routeEnd_query_val:string|null = decodeURIComponent(url_search_params.get("end_query_val"));
		if (routeEnd_query_val == "null") routeEnd_query_val = null;
		let tripID:string|null = decodeURIComponent(url_search_params.get("tripID"));
		if (tripID == "null") tripID = null;
		let isFRVT:string|null = decodeURIComponent(url_search_params.get("isFRVT"))

		show_map_loadingIcon("Loading your trip");
		$("#tripSearchModal").hide();
		window.history.replaceState({}, document.title, "/tripPlanner");
		get_genieTrip(tripID, JSON.parse(decodeURIComponent(url_search_params.get("genieTrip"))), driveTime, driveDist, routeWidth, avoidHighways, routeStart_query, routeEnd_query, routeStart_query_type, routeStart_query_val, routeEnd_query_type, routeEnd_query_val,isFRVT).then(trip => {
			window.tripPlannerCurrentTrip = trip;
			hide_map_loadingIcon();
			$("#tripSearchModal").remove();

			display_trip(trip, true);

			reset_interaction_counter();
		}).catch(e => {
			console.error(e);
			hide_map_loadingIcon();
			$("#tripSearchModal").show();
		});
    } else if (url_search_params.get("stops") != null) {
		const submit:boolean = url_search_params.get("submit")? url_search_params.get("submit").toLowerCase() == "true": false;

		if (url_search_params.get("unit") != null) {
			const unit = url_search_params.get("unit").toLowerCase();
			$("[dist-unit-select]").find("option[value='" + unit + "']").prop("selected", true);
		};

		if (url_search_params.get("driveDist") != null) {
			try {
				let driveDist:number = parseInt(url_search_params.get("driveDist"));
				$("#stopByStop_submitSearch").find("#drive-dist").val(driveDist);
			} catch {
				//do nothing;
			};
		};

		let stops_param_str:string = decodeURI(url_search_params.get("stops"));
		let stops_strings:string[] = stops_param_str.split("|");

		build_trip_from_query_args(stops_strings).then(() => {
			window.history.replaceState({}, document.title, "/tripPlanner");
			if (submit) $("#stopByStop_submitSearch").trigger("submit");
		});

    } else if (url_search_params.get("genieJourney") != null) {
		const submit:boolean = url_search_params.get("submit")? url_search_params.get("submit").toLowerCase() == "true": false;
		$("#tripPlannerAllInOne textarea").val(decodeURIComponent(url_search_params.get("genieJourney")));
		$("a[href='#magicSearch']").tab("show");
		window.history.replaceState({}, document.title, "/tripPlanner");
		if (submit) {
			//add delay to ensure event listeners initialized before form submission
			setTimeout(() => {
				$("#tripPlannerAllInOne").trigger("submit");
			}, 1000);
		};
    } else if (url_search_params.get("pubTrip") != null) {
		show_map_loadingIcon("Loading your trip");
		$("#tripSearchModal").hide();
		getPublishedTrip(url_search_params.get("pubTrip")).then(trip => {
			window.tripPlannerCurrentTrip = trip;
			hide_map_loadingIcon();
			$("#tripSearchModal").remove();

			display_trip(trip, true);

			reset_interaction_counter();
		}).catch(e => {
			console.error(e);
			hide_map_loadingIcon();
			$("#tripSearchModal").show();
		});
    } else {
        const tripCookie_str = getCookie_base64("trip");
		if (tripCookie_str.length) {
			getAccess('caching').then((cacheBool:boolean) => {
				if (cacheBool) {
					show_map_loadingIcon("Loading your trip");
					$("#tripSearchModal").hide();
					send_getCurTrip(tripCookie_str).then(trip => {
						window.tripPlannerCurrentTrip = trip;
						hide_map_loadingIcon();
						$("#tripSearchModal").remove();

						display_trip(trip, true);

						check_interaction_counter();

						if (trip.tripID) {
							window.history.replaceState({}, document.title, `/tripPlanner?id=${trip.tripID}`);
							getSaveTripBtn().then(btnHtml => {
								$("#saveTripWrap").html(btnHtml);
								$("#saveTripForm").off("submit");
								$("#saveTripForm").on("submit", handle_saveTrip_form);
							}).catch(e => {
								console.error(e);
							});
							getShareTripBtn().then(btnHtml => {
								$("#shareTripWrap").html(btnHtml);
								$("[tripPrivacyBtn]").off("click");
								$("[tripPrivacyBtn]").on("click", handleSharePopup);
							});
						};

					}).catch(e => {
						hide_map_loadingIcon();
						$("#tripSearchModal").show();
						if (e != "No Trip") console.error(e);
					});
				};
			});
		};
    }
};

(function () {
	window.addEventListener("load",onload,false);
})();